import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { StackModule } from '../stack/stack.module';

import { CardHeaderComponent } from './card-header.component';

@NgModule({
  declarations: [CardHeaderComponent],
  imports: [CommonModule, StackModule],
  exports: [CardHeaderComponent],
})
export class CardHeaderModule {}
